import {Component, OnInit, Input, Inject, Pipe, PipeTransform, Output, EventEmitter, AfterViewInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {VideoDialogComponent} from './../video-dialog/video-dialog.component';
import {MatChipInputEvent, MatSnackBar} from '@angular/material';
import {ConfService} from '../../conf.service';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent} from '@angular/material/typings/esm5/autocomplete';
import {interval, Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {Router} from '@angular/router';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {ApiintegrationsListenerService} from '../../apiintegrations-listener.service';
import {DialogComponent} from '../../shared/dialog/dialog.component';
import {ProviderCategoryComponent} from '../../settings/provider-category/provider-category.component';
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {MatChipsModule} from '@angular/material/chips';
import {DomSanitizer} from '@angular/platform-browser';
import {IntegrationsComponent} from '../../settings/integrations/integrations.component';
import {BusinessLogicDataService} from '../../new-blockly/business-logic-data.service';
import {AccountInfoService} from '../../user/account-info.service';

declare let $;

class ImageSnippet {
    constructor(public src: string, public file: File) {
    }
}

export interface Category {
    name: string;
}

@Component({
    selector: 'app-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {

    @Input() title: string;
    @Input() subTitle: string;
    @Input() cardType: string;
    @Input() cards: any;
    @Input() buttonType: string;
    @Input() checked: any;
    @Input() executor: any;
    @Input() selected: any;
    @Input() type: any;
    @Input() image: any;
    @Input() showSearchOption = true;
    masterList: any;
    avlList = {};
    subList = {};
    sampleUrl: any;
    partner: string;
    account: string;
    searchText = {
        title: ''
    };
    height = 160;
    width = 280;
    startSeconds = 0;
    endSeconds = 0;
    suggestedQuality = 'highres';
    videoId = 'sEYhnVzgrsw';
    @Output() changeInServiceProviders: EventEmitter<any> = new EventEmitter<any>();
    videosLoaded = [];

    componentLoading = true;
    cardLoading = true;
    // title = 'An introduction to navigate within apiplatform.io';

    constructor(private sanitizer: DomSanitizer,
                private integrationsListener: ApiintegrationsListenerService,
                public dialog: MatDialog,
                private confPost: ConfService,
                public platform: LeftpanelComponent,
                public accountInfoService: AccountInfoService,
                private router: Router,
                public _service: ConnecttocrudService,
                public Provider: ProviderCategoryComponent,
                public integrationComponent: IntegrationsComponent,
                private businessLogicDataService: BusinessLogicDataService) {

    }

    openDialog(src: string) {

        const dialogRef = this.dialog.open(VideoDialogComponent, {
            height: '28vw',
            width: '46%',
            data: {
                videoSrc: src,
            }
        });
    }

    openDialogSample(val: string) {
        for (let i = 0; i < this.sampleUrl.length; i++) {
            if (this.sampleUrl[i]['display_name'] === val) {
                const dialogRef = this.dialog.open(VideoDialogComponent, {
                    height: '28vw',
                    width: '46%',
                    data: {
                        videoSrc: this.sampleUrl[i]['video'],
                    }
                });
            }
        }
    }

    setAll(completed: boolean, id: any) {
        if (completed) {
            this.checked.push(id);
        } else {
            const index: number = this.checked.indexOf(id);
            if (index !== -1) {
                this.checked.splice(index, 1);
            }
        }
    }

    deselect(a: number, card: any) {
        this.executor.push(card);
        this.checked.splice(a, 1);
        this.cards.splice(a, 1);
    }

    Select(a: number, card: any) {
        this.checked.push(card.id);
        this.executor.push(card);
        this.cards.splice(a, 1);
    }

    addServiceProvider() {
        const dialogRef = this.dialog.open(AddServiceProviderComponent, {
            height: 'auto',
            width: '60%',
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result && result !== undefined) {
                this.cards.push(result);
            }
        });
    }

    addCategory() {
        const dialogRef = this.dialog.open(AddServiceProviderCategoryComponent, {
            height: 'auto',
            width: '46%',
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== 'cancel') {
                window.location.reload();
            }
        });
    }

    stringifyjson(val) {
        return JSON.stringify(val);
    }

    getEntity(card, cloneType) {
        this.confPost.getEntity(card.partner, card.account, card.entity, card.version).subscribe(data => {
            this.platform.cloneableData = data;
            if (cloneType === 'withoutData') {
                this.router.navigateByUrl(card.apiRoute + '?clone=' + true + '&data=' + false);
            } else {
                if (data['attributes'].length > 1000) {
                    if (confirm('Attributes in the schema exceeds the feasibility of cloning with data. You can still just clone the schema. Do you wish to continue?')) {
                        this.router.navigateByUrl(card.apiRoute + '?clone=' + true + '&data=' + false);
                    } else {
                        this.platform.cloneableData = undefined;
                    }
                } else {
                    this.router.navigateByUrl(card.apiRoute + '?clone=' + true + '&data=' + true);
                }
            }
        });
    }

    getSamplesViewPermissions() {
        if (this.cardType === 'sample') {
            switch (this.type) {
                case 'DATAACCESS':
                    return this.accountInfoService.hasPermission('VIEW_DATAACCESS_API_SAMPLES');
                    break;
                case 'BUSINESSLOGIC':
                    return this.accountInfoService.hasPermission('VIEW_BUSINESSLOGIC_API_SAMPLES');
                    break;
                case 'SQL Query':
                    return this.accountInfoService.hasPermission('VIEW_QUERYBUILDER_SAMPLES');
                    break;
                default:
                    return true;
                    break;
            }
        }
    }

    getPreviewTypesPermissions() {
        if (this.cardType === 'sample') {
            switch (this.type) {
                case 'DATAACCESS':
                    return this.accountInfoService.hasPermission('PREVIEW_DATAACCESS_API_SAMPLES');
                    break;
                case 'BUSINESSLOGIC':
                    return this.accountInfoService.hasPermission('PREVIEW_BUSINESSLOGIC_API_SAMPLES');
                    break;
                case 'SQL Query':
                    return this.accountInfoService.hasPermission('PREVIEW_QUERYBUILDER_SAMPLES');
                    break;
                default:
                    return true;
                    break;
            }
        }
    }

    getSamplesFilterPermissions() {
        if (this.cardType === 'sample') {
            switch (this.type) {
                case 'DATAACCESS':
                    return this.accountInfoService.hasPermission('FILTER_DATAACCESS_API_SAMPLES') ;
                    break;
                case 'BUSINESSLOGIC':
                    return this.accountInfoService.hasPermission('FILTER_BUSINESSLOGIC_API_SAMPLES');
                    break;
                case 'SQL Query':
                    return this.accountInfoService.hasPermission('FILTER_QUERYBUILDER_SAMPLES');
                    break;
                default:
                    return true;
                    break;
            }
        }
    }

    getSamplesPlayVideoPermissions() {
        if (this.cardType === 'sample') {
            switch (this.type) {
                case 'DATAACCESS':
                    return this.accountInfoService.hasPermission('PLAY_VIDEO_DATAACCESS_API_SAMPLES');
                    break;
                case 'BUSINESSLOGIC':
                    return this.accountInfoService.hasPermission('PLAY_VIDEO_BUSINESSLOGIC_API_SAMPLES');
                    break;
                case 'SQL Query':
                    return this.accountInfoService.hasPermission('PLAY_VIDEO_QUERYBUILDER_SAMPLES');
                    break;
                default:
                    return true;
                    break;
            }
        }
    }


    getExecutor(card) {
        this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(card.partner, card.account, card.entity, card.version).subscribe(exec => {
            this.platform.cloneableData = exec;
            this.router.navigateByUrl(card.apiRoute + '?clone=' + true);
        });
    }

    async subscribed(a, card) {
        this.businessLogicDataService.subscriptionsForceFetchNextCall = true;
        this.avlList[card.title] = true;
        card.isSubscribed = true;
        const index = this.integrationComponent.available.findIndex(obj => obj.title === card.title);
        if (this.masterList && !this.masterList['subscriptions']['providers']) {
            this.masterList['subscriptions']['providers'] = [];
        }
        this.masterList['subscriptions']['providers'].push(card['id']);
        await this._service.patchItemUpdate(this.masterList['id'], {subscriptions: this.masterList['subscriptions']}, 'v2', 'services', 'services', 'settings').subscribe(async success => {
            await Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'serviceprovider_activate_success', 'INFO', 200, 'OK', '', this.masterList['partner_settings'], success, this.router.url)).then(response => {
                const payloadToSend = {
                    actions: response
                };
                this.integrationsListener.apiIntegraionsListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            alert('Congratulations. You have activated the service provider successfully!');
            this.changeInServiceProviders.emit();
            this.selected.push(card);
            for (let i = 0; i < this.cards.length; i++) {
                if (this.cards[i]['id'] === card['id']) {
                    this.cards.splice(i, 1);
                    break;
                }
            }
            this.platform.b2bExecutors = undefined;
            await this.platform.getb2bAPIs();
            this.avlList[card.title] = false;
            if (this.integrationComponent.categoryServiceProviders) {
                // console.log('Before this.integrationComponent.available = ', this.integrationComponent.available);
                // console.log('Before this.integrationComponent.subscribedTemp = ', this.integrationComponent.subscribedTemp);
                // const index = this.integrationComponent.available.findIndex(obj => obj === card);
                this.integrationComponent.subscribedTemp.push(card);
                this.integrationComponent.available.splice(index, 1);
                // console.log('index = ', index, 'card = ', card);
                // console.log('After this.integrationComponent.available = ', this.integrationComponent.available);
                // console.log('Pop() this.integrationComponent.subscribedTemp = ', this.integrationComponent.subscribedTemp);
            }
        }, error => {
            let errorMessage = '';
            if (error.error['message']) {
                errorMessage = error.error.message;
            } else {
                const dialogRef = this.dialog.open(DialogComponent, {
                    data: {title: 'Error while Creating', message: error.error}
                });
                errorMessage = error.error;
            }
            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'serviceprovider_activate_failed', 'ERROR', error.status, error.statusText, errorMessage, this.masterList['partner_settings'], error, this.router.url)).then(response => {
                const payloadToSend = {
                    actions: response
                };
                this.integrationsListener.apiIntegraionsListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            alert('Error in activating the service provider. Please try again after sometime.');
            this.avlList[card.title] = false;
        });
    }

    async unsubscribed(a, card) {
        this.businessLogicDataService.subscriptionsForceFetchNextCall = true;
        this.subList[card.title] = true;
        card.isSubscribed = false;
        const index = this.integrationComponent.subscribedTemp.findIndex(obj => obj.title === card.title);
        if (confirm('Are you sure you want to unsubscribe?')) {
            card.isSubscribed = false;
            await this.getMasterList();
            for (let i = 0; i < this.masterList['subscriptions']['providers'].length; i++) {
                if (this.masterList['subscriptions']['providers'][i] === card['id']) {
                    this.masterList['subscriptions']['providers'].splice(i, 1);
                    break;
                }
            }
            // const temp = this.masterList['subscriptions']['providers'].indexOf(card['id']);
            // this.masterList['subscriptions']['providers'].splice(temp, 1);
            await this._service.patchItemUpdate(this.masterList['id'], this.masterList, 'v2', 'services', 'services', 'settings').toPromise().then(async data => {
                // this.matcheck = false;
                await Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'serviceprovider_deactivate_success', 'INFO', 200, 'OK', '', this.masterList, data, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.integrationsListener.apiIntegraionsListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                alert('You have successfully unsubscribed to the service provider.');
                this.changeInServiceProviders.emit();
                this.selected.push(card);
                for (let i = 0; i < this.cards.length; i++) {
                    if (this.cards[i]['id'] === card['id']) {
                        this.cards.splice(i, 1);
                        break;
                    }
                }
                this.subList[card.title] = false;
                this.platform.b2bExecutors = undefined;
                await this.platform.getb2bAPIs();
                if (this.integrationComponent.categoryServiceProviders) {
                    // console.log('Before this.integrationComponent.available = ', this.integrationComponent.available);
                    // console.log('Before this.integrationComponent.subscribedTemp = ', this.integrationComponent.subscribedTemp);
                    this.integrationComponent.available.push(card);
                    this.integrationComponent.subscribedTemp.splice(index, 1);
                    // console.log('index = ', index, 'card = ', card);
                    // console.log('After this.integrationComponent.available = ', this.integrationComponent.available);
                    // console.log('Pop() this.integrationComponent.subscribedTemp = ', this.integrationComponent.subscribedTemp);
                }
            }, error => {
                let errorMessage = '';
                if (error.error['message']) {
                    errorMessage = error.error.message;
                } else {
                    const dialogRef = this.dialog.open(DialogComponent, {
                        data: {title: 'Error while Creating', message: error.error}
                    });
                    errorMessage = error.error;
                }
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'serviceprovider_deactivate_failed', 'ERROR', error.status, error.statusText, errorMessage, this.masterList, error, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.integrationsListener.apiIntegraionsListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                alert('Error in deactivating the service provider. Please try again after sometime.');
                this.subList[card.title] = false;
            });
        } else {
            this.subList[card.title] = false;
            // this.matcheck = true;
            setTimeout(() => {
                card.isSubscribed = true;
            }, 100);

        }
    }

    getMasterList() {
        return new Promise((resolve, reject) => {
            this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(response => {
                this.masterList = response['body'][0];
                resolve('success');
            }, error => {
                resolve('failure');
            });
        });
    }

    initData() {
        if (this.cardType === 'connectorAvl' || this.cardType === 'connectorSubscribed' || this.cardType === 'connectorsAvlSub') {
            this.getMasterList();
        }
        // for (let i = 0; i < this.cards.length; i++) {
        //     if (this.cardType === 'connectorAvl') {
        //         this.cards[i]['isSubscribed'] = false;
        //     } else if (this.cardType === 'connectorSubscribed') {
        //         this.cards[i]['isSubscribed'] = true;
        //     }
        //     this.videosLoaded[i] = false;
        // }

        if (this.cardType === 'sample') {
            this.confPost.getData('services', 'services', 'v1', 'platformContent', 'name=samples').subscribe(data => {
                this.sampleUrl = data[0]['settings'];
                for (let i = 0; i < this.cards.length; i++) {
                    for (let j = 0; j < this.sampleUrl.length; j++) {
                        if (this.cards[i]['title'] === this.sampleUrl[j]['display_name']) {
                            this.cards[i]['image'] = this.sampleUrl[j]['thumbnail'];
                        }
                    }
                }
            });
        }

        $(document).ready(function () {
            $('#myInput').on('keyup', function () {
                const value = $(this).val().toString().toLowerCase();
                $('.connectorAvl').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    return true;
                });
            });
        });
        $(document).ready(function () {
            $('#myInput12').on('keyup', function () {
                const value = $(this).val().toString().toLowerCase();
                $('.providerscat').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    return true;
                });
            });
        });
        $(document).ready(function () {
            $('#myInputavl').on('keyup', function () {
                const value = $(this).val().toString().toLowerCase();
                $('.connectoravl').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    return true;
                });
            });
        });
        $(document).ready(function () {
            $('#myInputsub').on('keyup', function () {
                const value = $(this).val().toString().toLowerCase();
                $('.connectorsub').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    return true;
                });
            });
        });
        $(document).ready(function () {
            $('#myInputchecked').on('keyup', function () {
                const value = $(this).val().toString().toLowerCase();
                $('.checked').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    return true;
                });
            });
        });
        $(document).ready(function () {
            $('#myInput12').on('keyup', function () {
                const value = $(this).val().toString().toLowerCase();
                $('.connectorSubscribed').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    return true;
                });
            });
        });
        $(document).ready(function () {
            $('#myInput1').on('keyup', function () {
                const value = $(this).val().toString().toLowerCase();
                $('.avail').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    return true;
                });
            });
        });
        $(document).ready(function () {
            $('#myInput2').on('keyup', function () {
                const value = $(this).val().toString().toLowerCase();
                $('.selectd').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    return true;
                });
            });
        });


        // TODO
        $(document).ready(function () {
            $('#sampleBUSINESSLOGIC').on('keyup', function () {
                const value = $(this).val().toString().toLowerCase();
                $('.connector').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    return true;
                });
            });
        });
        $(document).ready(function () {
            $('#sampleWORKFLOW').on('keyup', function () {
                const value = $(this).val().toString().toLowerCase();
                $('.connector').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    return true;
                });
            });
        });
        $(document).ready(function () {
            $('#sampleDATAACCESS').on('keyup', function () {
                const value = $(this).val().toString().toLowerCase();
                $('.connector').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    return true;
                });
            });
        });


    }

    ngOnInit(): void {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        this.partner = localStorage.getItem('partner');
        this.account = localStorage.getItem('account');

        const permissionSubscription = interval(500).subscribe((async x => {
            this.initData();
            permissionSubscription.unsubscribe();
            this.componentLoading = false;
        }));
        setTimeout(() => {
            this.cardLoading = false;
        }, 10000);
    }


}



@Pipe({name: 'filterCard', pure: false})
export class filterCard implements PipeTransform {
    transform(listOfNames: any[], nameToFilter: object): string[] {
        if (!listOfNames) {
            return null;
        }
        if (!nameToFilter) {
            return listOfNames;
        }
        return listOfNames.filter(listOfNames => this.toLower(listOfNames.title).indexOf(nameToFilter['title'].toLowerCase()) >= 0);
    }

    toLower(val) {
        return val.toLowerCase();
    }
}

@Pipe({name: 'filterCollection', pure: false})
export class filterCollection implements PipeTransform {
    transform(listOfNames: any[], nameToFilter: object): string[] {
        if (!listOfNames) {
            return null;
        }
        if (!nameToFilter) {
            return listOfNames;
        }
        return listOfNames.filter(listOfNames => this.toLower(listOfNames.title).indexOf(nameToFilter['title'].toLowerCase()) >= 0);
    }

    toLower(val) {
        if (val === null || val === undefined) {
            return '';
        } else {
            return val.toLowerCase();
        }
    }
}

@Pipe({name: 'filterCardbyName', pure: false})
export class filterCardByName implements PipeTransform {
    transform(listOfNames: any[], nameToFilter: object): string[] {
        if (!listOfNames) {
            return null;
        }
        if (!nameToFilter) {
            return listOfNames;
        }
        return listOfNames.filter(listOfNames => this.toLower(listOfNames.name).indexOf(nameToFilter['title'].toLowerCase()) >= 0);
    }

    toLower(val) {
        return val.toLowerCase();
    }
}

@Component({
    selector: 'app-addserviceprovider',
    templateUrl: 'add-service-provider.component.html',
    styleUrls: ['add-service-provider.component.css']
})
export class AddServiceProviderComponent implements OnInit {

    password: any;
    connectorName: any;
    loading = false;
    loading1 = false;
    apiProducers = [];

    payload = {
        producer: '',
        title: '',
        description: '',
        image: '',
        url: '',
        authorization: [],
        partner: localStorage.getItem('partner'),
        account: localStorage.getItem('account'),
        isPromoted: false
    };

    selectedFile: any;
    error: boolean;
    s3URL: any;

    settings = {
        text: 'Select Authorization Types',
        // selectAllText: 'Select All',
        // unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };

    settings1 = {
        text: 'Select Category',
        // selectAllText: 'Select All',
        // unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };

    authorizationList = [];
    flag = false;
    authorizationTypes = [];
    selectable = true;
    removable = true;
    addOnBlur = true;
    categories = [];
    categoryArray = [];
    categoriesControl = new FormControl([]);


    readonly separatorKeysCodes: number[] = [ENTER, COMMA];

    constructor(
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<AddServiceProviderComponent>,
        private confPost: ConfService, public platform: LeftpanelComponent, private router: Router, private integrationsListener: ApiintegrationsListenerService,
        @Inject(MAT_DIALOG_DATA) public data: any, private _service: ConnecttocrudService) {
        this.dialogRef.disableClose = true;
    }

    private removeFirst(array, toRemove): void {

        const index = array.indexOf(toRemove);
        if (index !== -1) {
            array.splice(index, 1);
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }

    onCatRemoved(cat: string) {
        const categories = this.categoriesControl.value as string[];
        this.removeFirst(categories, cat);
        this.categoriesControl.setValue(categories); // To trigger change detection
    }

    addConfigurations() {
        let nameLength = 0;
        if (this.payload.producer && this.payload.producer !== null && this.payload.producer !== undefined) {
            for (let i = 0; i < this.payload.producer.length; i++) {
                if (this.payload.producer.charCodeAt(i) === 8 || this.payload.producer.charCodeAt(i) === 32 || (this.payload.producer.charCodeAt(i) > 64 && this.payload.producer.charCodeAt(i) < 91) || (this.payload.producer.charCodeAt(i) > 96 && this.payload.producer.charCodeAt(i) < 123) || (this.payload.producer.charCodeAt(i) >= 48 && this.payload.producer.charCodeAt(i) <= 57)) {
                    nameLength++;
                }
            }
        }
        if (this.payload.producer !== '' && this.payload.producer !== null && this.payload.producer !== undefined && this.payload.producer.length === nameLength) {
            this.loading = true;
            // for (const type of this.authorizationTypes) {
            //     this.payload.authorization.push(type['itemName']);
            // }
            if (this.payload.url !== '' && this.payload.image !== '' && this.payload.producer !== '') {
                if (this.payload.url !== '' && this.payload.producer !== '' && this.payload.image !== '' && this.categoryArray.length > 0) {
                    // if ((this.apiProducers.filter(element => element.producer.toLowerCase() === this.payload.producer.toLowerCase())).length === 0) {
                    this._service.addItem(this.payload, 'v1', 'services', 'services', 'apiproducers').subscribe(async response => {
                        const temp = {
                            account: localStorage.getItem('account'),
                            partner: localStorage.getItem('partner'),
                            producer: this.payload.producer,
                            connectors: []
                        };
                        this._service.addItem(temp, 'v1', 'services', 'services', 'apiconnectors').subscribe(res => {
                        });
                        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'serviceprovider_provider_create_success', 'INFO', 200, 'OK', '', this.payload, response, this.router.url)).then(response1 => {
                            const payloadToSend = {
                                actions: response1
                            };
                            this.integrationsListener.apiIntegraionsListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });
                        await this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(async data => {
                            const payload = JSON.parse(JSON.stringify(data['body'][0]));
                            payload['subscriptions']['providers'].push(response['upsertedId']);
                            await this.confPost.patchEntityData('services', 'services', 'v2', 'settings', data['body'][0]['id'], payload).subscribe(res => {
                            });
                        });
                        for (const category of this.categoryArray) {
                            this.confPost.getData('services', 'services', 'v1', 'producerCategories', 'name=' + category['itemName'] + '&dbref=false').subscribe(response1 => {
                                for (const providerCategory of this.categories) {
                                    if (category['itemName'] === providerCategory['itemName']) {
                                        let tempCategory = [];
                                        if (response !== null) {
                                            const body = response['body'];
                                            tempCategory = response1[0]['serviceProvider'];
                                            tempCategory.push(response['upsertedId']);
                                        }
                                        const tempPayload = {
                                            serviceProvider: tempCategory
                                        };
                                        this.confPost.patchProviderCategory(tempPayload, response1[0]['id']).subscribe(response2 => {
                                            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'serviceprovider_providercategory_patch_success', 'INFO', 200, 'OK', '', this.payload, tempPayload, this.router.url)).then(response3 => {
                                                const payloadToSend = {
                                                    actions: response3
                                                };
                                                this.integrationsListener.apiIntegraionsListener.emit({
                                                    type: 'audit',
                                                    id: localStorage.getItem('IdOfSession'),
                                                    payload: payloadToSend
                                                });
                                            });
                                        }, error => {
                                            let errorMessage = '';
                                            if (error.error['message']) {
                                                errorMessage = error.error.message;
                                            } else {
                                                const dialogRef = this.dialog.open(DialogComponent, {
                                                    data: {title: 'Error while Creating', message: error.error}
                                                });
                                                errorMessage = error.error;
                                            }
                                            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'serviceprovider_providercategory_patch_failed', 'ERROR', error.status, error.statusText, errorMessage, tempPayload, error, this.router.url)).then(response4 => {
                                                const payloadToSend = {
                                                    actions: response4
                                                };
                                                this.integrationsListener.apiIntegraionsListener.emit({
                                                    type: 'audit',
                                                    id: localStorage.getItem('IdOfSession'),
                                                    payload: payloadToSend
                                                });
                                            });
                                        });
                                    }
                                }
                            });
                        }
                        this.platform.openSnackBar('Service Provider added succesfully', 'Success', {
                            duration: 3000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.dialogRef.close(this.payload);
                    }, error => {
                        let errorMessage = '';
                        if (error.error['message']) {
                            errorMessage = error.error.message;
                        } else {
                            const dialogRef = this.dialog.open(DialogComponent, {
                                data: {title: 'Error while Creating', message: error.error}
                            });
                            errorMessage = error.error;
                        }
                        Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'serviceprovider_provider_create_failed', 'ERROR', error.status, error.statusText, errorMessage, this.payload, error, this.router.url)).then(response4 => {
                            const payloadToSend = {
                                actions: response4
                            };
                            this.integrationsListener.apiIntegraionsListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });
                    });
                    // } else {
                    //     this.platform.openSnackBar('Service Producer with the name already exists', 'Error', {
                    //         duration: 2000,
                    //         verticalPosition: 'top',
                    //         horizontalPosition: 'center'
                    //     });
                    //     this.loading = false;
                    // }
                } else {
                    this.platform.openSnackBar('Please enter all mandatory fields', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loading = false;
                }
            } else {
                this.platform.openSnackBar('Please enter all mandatory fields', 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.loading = false;
            }
        } else {
            this.platform.openSnackBar('Please enter a valid service provider name', 'Error', {
                duration: 2000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    add(event, data) {
        const input = event.input;
        const value = event.value;

        // Add our fruit
        if ((value || '').trim()) {
            data.push(value.trim());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    remove(val, data) {
        const index = data.indexOf(val);

        if (index >= 0) {
            data.splice(index, 1);
        }
    }

    processFile(imageInput: any) {
        this.loading1 = true;
        this.error = false;
        const file: File = imageInput.files[0];
        const reader = new FileReader();

        reader.addEventListener('load', (event: any) => {

            this.selectedFile = new ImageSnippet(event.target.result, file);
            this.confPost.uploadToS3Bucket(this.selectedFile.file.name, 'services', this.selectedFile.file, 'apiproducerslogo', 'apiplatformio').subscribe(
                (res) => {
                    this.payload.image = res['s3URL'];
                    this.platform.openSnackBar('File ' + this.selectedFile.file.name + ' is uploaded successfully', 'Success', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loading1 = false;
                },
                (err) => {
                    this.loading1 = false;
                    this.platform.openSnackBar('Error occured while upload, Please try after sometime', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });
        reader.readAsDataURL(file);
    }

    addCategory() {
        const dialogRef = this.dialog.open(AddServiceProviderCategoryComponent, {
            height: 'auto',
            width: '46%',
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== null && result !== undefined) {
                const tempObj = {};
                tempObj['itemName'] = result;
                this.categoryArray.push(tempObj);
                tempObj['id'] = this.categories.length - 1;
                this.categories.push(tempObj);
            }
        });
    }

    selectEvent(val) {
        const temp = [];
        for (let i = 0; i < val.configurations.length; i++) {
            temp.push({key: val.configurations[i]['name'], displayname: val.configurations[i]['displayName']});
        }
        this.payload.authorization.push({authtype: val.itemName, authattributes: temp});
    }

    deselect(val) {
        let index;
        for (let i = 0; i < this.payload.authorization.length; i++) {
            if (this.payload.authorization[i]['authtype'] === val['itemName']) {
                index = i;
                break;
            }
        }
        // const index = this.payload.authorization.indexOf({authtype: val['itemName'], authattributes: val['configurations']});
        this.payload.authorization.splice(index, 1);
    }

    deleteatt(val1, val2) {
        this.payload['authorization'][val1]['authattributes'].splice(val2, 1);
    }

    addatt(val) {
        this.payload['authorization'][val]['authattributes'].push({key: ''});
    }

    selectall() {
        this.payload.authorization = [];
        for (let j = 0; j < this.authorizationList.length; j++) {
            const temp = [];
            for (let i = 0; i < this.authorizationList[j].configurations.length; i++) {
                temp.push({
                    key: this.authorizationList[j].configurations[i]['name'],
                    displayname: this.authorizationList[j].configurations[i]['displayName']
                });
            }
            this.payload.authorization.push({authtype: this.authorizationList[j].itemName, authattributes: temp});
        }
    }

    deselectall() {
        this.payload.authorization = [];
    }

    ngOnInit() {

        this.confPost.getData('services', 'services', 'v1', 'producerCategories', null).subscribe(response => {
            const temp = [];
            const iterator = response[Symbol.iterator]();
            while (true) {
                const tempObject = iterator.next();
                if (tempObject.done) {
                    break;
                }
                temp.push(tempObject.value);
            }
            for (let t = 0; t < temp.length; t++) {
                if (temp[t]['isActive'] === true) {
                    const tempObj = {};
                    tempObj['id'] = t;
                    tempObj['itemName'] = temp[t]['name'];
                    this.categories.push(tempObj);
                }
            }
        });

        this.confPost.getData('services', 'services', 'v1', 'apiProducers', null).subscribe(response => {
            const temp = [];
            const iterator = response[Symbol.iterator]();
            while (true) {
                const tempObject = iterator.next();
                if (tempObject.done) {
                    break;
                }
                this.apiProducers.push(tempObject.value);
            }
        });

        this.confPost.getData('services', 'services', 'v1', 'authorizationConfigurations', null).subscribe(response => {
            const temp = [];
            const iterator = response[Symbol.iterator]();
            while (true) {
                const tempObject = iterator.next();
                if (tempObject.done) {
                    break;
                }
                temp.push(tempObject.value);
            }
            for (let t = 0; t < temp.length; t++) {
                const tempObj = {};
                tempObj['id'] = t;
                tempObj['itemName'] = temp[t]['authType'];
                tempObj['configurations'] = temp[t]['authAttributes'];
                this.authorizationList.push(tempObj);
            }
        });
    }

}

@Component({
    selector: 'app-addserviceprovidercategory',
    templateUrl: 'add-service-provider-category.component.html',
    styleUrls: ['add-service-provider-category.component.css']
})
export class AddServiceProviderCategoryComponent implements OnInit {

    payload = {
        name: '',
        description: '',
        logo: '',
        serviceProvider: [],
        partner: localStorage.getItem('partner'),
        account: localStorage.getItem('account'),
        isPromoted: false
    };

    error: boolean;
    loading = false;
    loading1 = false;

    selectedFile: any;
    categories = [];

    constructor(
        public dialogRef: MatDialogRef<AddServiceProviderCategoryComponent>,
        private confPost: ConfService, public platform: LeftpanelComponent, private router: Router, private integrationsListener: ApiintegrationsListenerService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.dialogRef.disableClose = true;
    }

    ngOnInit() {

        this.confPost.getData('services', 'services', 'v1', 'producerCategories', null).subscribe(response => {
            const iterator = response[Symbol.iterator]();
            while (true) {
                const tempObject = iterator.next();
                if (tempObject.done) {
                    break;
                }
                this.categories.push(tempObject.value);
            }
        });

    }

    closeDlg() {
        this.dialogRef.close();
    }

    processFile(imageInput: any) {
        this.loading1 = true;
        this.error = false;
        const file: File = imageInput.files[0];
        const reader = new FileReader();

        reader.addEventListener('load', (event: any) => {

            this.selectedFile = new ImageSnippet(event.target.result, file);
            this.confPost.uploadToS3Bucket(this.selectedFile.file.name, 'services', this.selectedFile.file, 'APIProducersCategoriesLogo', 'default').subscribe(
                (res) => {
                    this.payload.logo = res['s3URL'];
                    this.platform.openSnackBar('File ' + this.selectedFile.file.name + 'is uploaded successfully', 'Success', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                },
                (err) => {
                    this.loading1 = false;
                    this.platform.openSnackBar('Error occurred while upload, Please try after sometime', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });
        reader.readAsDataURL(file);
    }

    addCategory() {
        if (this.payload.name !== '' && this.payload.description !== '') {
            this.loading = true;
            if (localStorage.getItem('partner') === 'services') {
                this.payload['isPromoted'] = true;
            }
            this.payload['isActive'] = true;
            if ((this.categories.filter(element => element.name.toLowerCase() === this.payload.name.toLowerCase())).length === 0) {
                this.confPost.addServiceProviderCategory(this.payload).subscribe(response => {
                    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'serviceprovider_category_create_success', 'INFO', 200, 'OK', '', this.payload, response, this.router.url)).then(response1 => {
                        const payloadToSend = {
                            actions: response1
                        };
                        this.integrationsListener.apiIntegraionsListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    this.platform.openSnackBar('Category added successfully', 'Success', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.dialogRef.close(this.payload.name);
                }, error => {
                    let errorMessage = '';
                    if (error.error['message']) {
                        errorMessage = error.error.message;
                    } else {
                        errorMessage = error.error;
                    }
                    Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'serviceprovider_category_create_failed', 'ERROR', error.status, error.statusText, errorMessage, this.payload, error, this.router.url)).then(response4 => {
                        const payloadToSend = {
                            actions: response4
                        };
                        this.integrationsListener.apiIntegraionsListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    this.platform.openSnackBar('Error in adding a category. Please try again after sometime', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loading = false;
                });
            } else {
                this.platform.openSnackBar('Category already exists', '', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.loading = false;
            }
        } else {
            alert('Please make sure you have provided all the values');
            this.loading = false;
        }
    }

}
